import { Box, styled, Typography } from '@mui/material';

import { Icon } from '»components/atoms';

export const FooterStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.colors.onFooterBackground,
  right: 0,
  bottom: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  padding: '24px 0 40px',
  alignItems: 'center',

  [theme.breakpoints.up('sm')]: {
    padding: '32px 0 52px',
  },
  [theme.breakpoints.up('md')]: {
    padding: '32px 0 60px',
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    padding: '58px 0 109px',
  },
  [theme.breakpoints.up('xxl')]: {
    padding: '41px 0 66px',
  },
}));

export const CompanyInfoStyled = styled(Box)(() => ({
  maxWidth: 222,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
}));

export const IconStyled = styled(Icon)(() => ({
  height: '46px',
}));

export const DescriptionStyled = styled(Typography)(({ theme }) => ({
  marginLeft: 54,
  marginTop: 20,
  fontSize: 12,
  fontWeight: 500,
  width: '157px',

  [theme.breakpoints.up('md')]: {
    width: '222px',
  },
}));
